import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

/**
 * Export a DOM element to PDF
 * @param {HTMLElement} element - The DOM element to capture
 * @param {string} filename - The filename (without .pdf extension)
 */
export const exportToPdf = async (element, filename = 'document') => {
    if (!element) {
        throw new Error('No element to export');
    }

    // Capture the element as canvas
    const canvas = await html2canvas(element, {
        scale: 2, // Higher quality
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
    });

    const imgData = canvas.toDataURL('image/png');
    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    // Create PDF
    const pdf = new jsPDF('p', 'mm', 'a4');
    let heightLeft = imgHeight;
    let position = 0;
    const footerLineY = pageHeight - 8;

    const drawFooterLine = () => {
        pdf.setDrawColor(200, 200, 200);
        pdf.setLineWidth(0.2);
        pdf.line(0, footerLineY, imgWidth, footerLineY);
    };

    // Add first page
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    drawFooterLine();
    heightLeft -= pageHeight;

    // Add additional pages if content is longer
    while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        drawFooterLine();
        heightLeft -= pageHeight;
    }

    // Download
    pdf.save(`${filename.replace(/[^a-zA-Z0-9-_]/g, '_')}.pdf`);
};

export default exportToPdf;
